import React from "react";
import sectionsArray from "../../constants/sectionsArray";
import { Observable } from "./Observable";

export const SectionsObserver = () => {
  return <>{sectionsArray.map((el, index) => (<Observable key={index} Item={el}/>))}</>;
};
